import { IamClient, IamWrapper } from "iam-client";
import React, { useCallback, useEffect, useState } from "react";

interface LoginContextType {
  email: string;
  isUserLogged: boolean;
  fetchAuthenticatedUser: () => void;
  logOut: () => void;
}

export const UserContext = React.createContext({} as LoginContextType);

interface UserContextProviderProps {
  children: React.ReactNode;
}

export default function UserContextProvider({
  children,
}: UserContextProviderProps): React.JSX.Element {
  const [userLoaded, setUserLoaded] = useState(false);
  const [email, setEmail] = useState(null);

  const logOut = useCallback(async () => {
    await IamClient.logOut();
    setEmail(null);
  }, []);

  const fetchAuthenticatedUser = useCallback(async () => {
    await IamWrapper.getSelf({
      onUserLoggedIn: (e) => {
        setEmail(e);
        setUserLoaded(true);
      },
      onUserNotLoggedIn: () => {
        setEmail(null);
        setUserLoaded(true);
      },
    });
  }, []);

  const isUserLogged = Boolean(email);

  useEffect(() => {
    fetchAuthenticatedUser();
  }, [fetchAuthenticatedUser]);

  return (
    <UserContext.Provider
      value={{
        email,
        isUserLogged,
        fetchAuthenticatedUser,
        logOut,
      }}
    >
      {userLoaded && children}
    </UserContext.Provider>
  );
}
